<template>
	<div class="bg-struct bg-struct-details bg-img bg-img-18"></div>
	<div class="main-cont">
		<div id="portfolio_sec" class="mb-5">&nbsp;</div>
		<section class="portfolio-sec">
			<div class="d-flex justify-content-between mb-3">
				<h4 style="z-index: 1;">Блог</h4>
				<div class="d-none d-lg-block">
					<div class="btn-group" role="group">
						<button @click="onSelCategory()" class="btn btn-dark" :class="{'active': category == null}">ВСЕ</button>
						<button @click="onSelCategory(blogcat.id)" class="btn btn-dark" :class="{'active': category == blogcat.id}" v-for="blogcat in blogCategories" :key="blogcat.id">{{blogcat.name}}</button>
					</div>
					<div class="btn-group ms-1" role="group" v-if="authModel.isAdmin()">
						<router-link :to="{path: '/admin/blog/add', query: Object.assign({}, this.$route.query, {
							category: this.$route.query.category,
							page: this.$route.query.page,
						})}" class="btn btn-primary">
							<font-awesome-icon :icon="['fas', 'plus']" />
						</router-link>
					</div>
				</div>
				<div class="d-block d-lg-none">
					<div class="dropdown">
						<button class="btn btn-dark px-3" type="button" data-bs-toggle="dropdown" aria-expanded="false">
							<font-awesome-icon :icon="['fas', 'list']" />
						</button>
						<ul class="dropdown-menu dropdown-menu-end">
							<li>
								<button @click="onSelCategory()" class="dropdown-item py-2" :class="{'active': category == null}">Все записи</button>
							</li>
							<li v-for="blogcat in blogCategories" :key="blogcat.id">
								<button @click="onSelCategory(blogcat.id)" class="dropdown-item py-2" :class="{'active': category == blogcat.id}">{{blogcat.name}}</button>
							</li>
						</ul>
						<div class="btn-group ms-1" role="group" v-if="authModel.isAdmin()">
							<router-link :to="{path: '/admin/blog/add', query: Object.assign({}, this.$route.query, {
								category: this.$route.query.category,
								page: this.$route.query.page,
							})}" class="btn btn-primary">
								<font-awesome-icon :icon="['fas', 'plus']" />
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="card border-0 shadow-sm text-center" v-if="loading">
				<div class="card-body py-4">
					<loading-spinner color="white" text="ЗАГРУЗКА..." />
				</div>
			</div>
			<div class="card border-0 shadow-sm text-center"  v-if="!loading && !blog">
				<div class="card-body py-4">
					<h1>ЗАПИСЕЙ ПОКА НЕТ</h1>
				</div>
			</div>
			<div v-if="!loading && blog">
				<div class="gallery-wrap">
					<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
						<div class="col" v-for="blogitem in blog" :key="blogitem.id">
							<router-link :to="{path: '/blog/'+blogitem.id, query: Object.assign({}, this.$route.query, {
								category: this.category,
								page: this.page,
							})}" class="card border-0 shadow-sm text-decoration-none h-100">
								<div class="card-img-cont">
									<div class="card-img-out">
										<div class="card-img-in">
											<img :src="blogitem.poster ? blogitem.poster.url_small : '/assets/img/no-image.svg'" />
										</div>
									</div>
								</div>
								<div class="card-body">
									<div class="card-text text-body-secondary">{{blogitem.category_name}}</div>
									<h5 class="card-title">{{blogitem.title}}</h5>
								</div>
								<div class="card-footer">
									<small class="text-body-secondary">{{formatDate(blogitem.dateadd, 'DD.MM.YYYY')}}</small>
								</div>
							</router-link>
						</div>
					</div>
				</div>
				<div class="text-center mt-4">
					<div v-if="$device.isMobile">
						<span @click="gotoPage(1)" class="btn btn-white float-start me-1" :class="{'disabled': page == 1}">
							<font-awesome-icon :icon="['fas', 'angles-left']" />
						</span>
						<span @click="gotoPage(page - 1)" class="btn btn-white float-start" :class="{'disabled': page == 1}">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
						</span>
						<span @click="gotoPage(getPagesCount())" class="btn btn-white float-end ms-1" :class="{'disabled': page == getPagesCount()}">
							<font-awesome-icon :icon="['fas', 'angles-right']" />
						</span>
						<span @click="gotoPage(page + 1)" class="btn btn-white float-end" :class="{'disabled': page == getPagesCount()}">
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</span>
						<span class="btn btn-white">{{page}} из {{getPagesCount()}}</span>
					</div>
					<div class="btn-group" v-else>
						<span @click="gotoPage(1)" class="btn btn-white" :class="{'disabled': page == 1}">
							<font-awesome-icon :icon="['fas', 'angles-left']" />
						</span>
						<span @click="gotoPage(page - 1)" class="btn btn-white" :class="{'disabled': page == 1}">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
						</span>
						<span @click="gotoPage(1)" class="btn btn-white" :class="{'active': page == 1}">1</span>
						<span class="btn btn-white disabled" v-if="page - paginationAlpha > 2">...</span>
						<span @click="gotoPage(i)" class="btn btn-white" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-if="paginationA2 >= paginationA1">{{i}}</span>
						<span class="btn btn-white disabled" v-if="page + paginationAlpha < getPagesCount() - 1">...</span>
						<span @click="gotoPage(getPagesCount())" class="btn btn-white" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">{{getPagesCount()}}</span>
						<span @click="gotoPage(page + 1)" class="btn btn-white" :class="{'disabled': page == getPagesCount()}">
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</span>
						<span @click="gotoPage(getPagesCount())" class="btn btn-white" :class="{'disabled': page == getPagesCount()}">
							<font-awesome-icon :icon="['fas', 'angles-right']" />
						</span>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
	name: "Blog",
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Портфолио | byLex Portfolio'});
	},
	data: () => ({
		category: null,
		
		blogCategories: [],
		blog: [],
		blogCount: 0,
		
		page: 1,
		limit: 9,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		range: lib.range,
		formatDate: lib.formatDate,
		number_format: lib.number_format,
		
		async loadBlogCategories(){
			this.error = '';
			let ret = await this.appModel.doGetBlogCategories();
			if(ret.success){
				this.blogCategories = ret.list;
			} else {
				this.error = ret.message;
			}
		},
		async loadData(){
			this.loading = true;
			this.error = '';
			this.$router.push({query: Object.assign({}, this.$route.query, {
				category: this.category,
				page: this.page,
			})});
			let params = {
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			if(this.category){
				params.category_id = this.category;
			}
			let ret = await this.appModel.doGetBlog(params);
			if(ret.success){
				this.blog = ret.list;
				this.blogCount = ret.list_count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		onSelCategory(category_id = null){
			this.category = category_id;
			thos.page = 1;
			this.loadData();
			window.scrollTo(0, 0);
		},
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.blogCount / this.limit);
		},
		
		getDateDuration(obj){
			return (obj.dateend != '0000-00-00 00:00:00' ?
					(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(obj.dateend, 'YYYY-MM-DD')).days + 1)+
					' '+
					lib.decl1(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(obj.dateend, 'YYYY-MM-DD')).days + 1)
				:
					(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(new Date().toUTCString(), 'YYYY-MM-DD')).days + 1)+
					' '+
					lib.decl1(lib.dateDiff(this.formatDate(obj.dateadd, 'YYYY-MM-DD'), this.formatDate(new Date().toUTCString(), 'YYYY-MM-DD')).days + 1)
				);
		},
	},
	async mounted(){
		if(this.$route.query.category) this.category = this.$route.query.category;
		if(this.$route.query.page) this.page = parseInt(this.$route.query.page || 1);
		
		this.loading = true;
		await this.loadBlogCategories();
		await this.loadData();
		this.loading = false;
		//window.scrollTo(0, 0);
	},
	components: {
		LoadingSpinner,
	},
}
</script>
